import { useTranslation } from 'react-i18next';

import { InfoCard } from 'core/components';
import { getValue } from 'core/utils';
import { IVendorQuote } from 'quotes/types';

interface IProps {
  quote: IVendorQuote;
}

export const QuotedByInfo = ({ quote }: IProps) => {
  const { t } = useTranslation();

  return (
    <InfoCard
      title={t('titleQuotedBy')}
      items={[
        {
          label: getValue(quote, 'vendorContactGroupName') as string,
          value: [
            getValue(quote, 'vendorContactName'),
            getValue(quote, 'vendorContactPhone'),
            getValue(quote, 'locationName'),
          ],
        },
      ]}
    />
  );
};
